import { useState, useContext } from 'react';
import { Modal, ModalDialog, ModalClose, Typography, Stack, Button, Textarea, RadioGroup, Radio, FormControl, FormLabel, Sheet } from '@mui/joy';
import { LayoutContext } from '../../context';
import { APICreateQuestionReport } from '../../api';

const REPORT_TYPES = [
    { value: 'wrong_answer', label: 'Неверный ответ' },
    { value: 'unclear_explanation', label: 'Непонятное объяснение' },
    { value: 'duplicate', label: 'Дубликат вопроса' },
    { value: 'typo', label: 'Опечатка' },
    { value: 'outdated', label: 'Устаревшая информация' },
    { value: 'other', label: 'Другое' },
];

export default function ReportModal({ open, onClose, questionId }) {
    const { token } = useContext(LayoutContext);
    const [reportType, setReportType] = useState('wrong_answer');
    const [description, setDescription] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        setSubmitting(true);
        setError('');
        try {
            const res = await APICreateQuestionReport(token, {
                question_id: questionId,
                report_type: reportType,
                description: description.trim()
            });
            if (res.success) {
                setSuccess(true);
                setTimeout(() => {
                    onClose();
                    setSuccess(false);
                    setReportType('wrong_answer');
                    setDescription('');
                }, 1500);
            } else {
                setError(res.error || 'Ошибка при отправке');
            }
        } catch (e) {
            const msg = e?.response?.data?.error;
            setError(typeof msg === 'string' ? msg : 'Ошибка при отправке жалобы');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <ModalDialog sx={{ maxWidth: 450, width: '100%' }}>
                <ModalClose />
                <Typography level="h4" sx={{ mb: 2 }}>
                    Пожаловаться на вопрос
                </Typography>

                {success ? (
                    <Sheet variant="soft" color="success" sx={{ p: 3, borderRadius: 'md', textAlign: 'center' }}>
                        <Typography level="body-lg" color="success">
                            Жалоба отправлена! Спасибо за помощь.
                        </Typography>
                    </Sheet>
                ) : (
                    <Stack spacing={2}>
                        <FormControl>
                            <FormLabel>Тип проблемы</FormLabel>
                            <RadioGroup
                                value={reportType}
                                onChange={(e) => setReportType(e.target.value)}
                            >
                                {REPORT_TYPES.map((rt) => (
                                    <Radio key={rt.value} value={rt.value} label={rt.label} />
                                ))}
                            </RadioGroup>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Описание (необязательно)</FormLabel>
                            <Textarea
                                placeholder="Расскажите подробнее о проблеме..."
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                minRows={2}
                                maxRows={4}
                            />
                        </FormControl>

                        {error && (
                            <Typography level="body-sm" color="danger">{error}</Typography>
                        )}

                        <Button
                            variant="solid"
                            color="danger"
                            loading={submitting}
                            onClick={handleSubmit}
                        >
                            Отправить жалобу
                        </Button>
                    </Stack>
                )}
            </ModalDialog>
        </Modal>
    );
}
